import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';

const SuccessModal = ({
  show,
  onHide,
  title = 'Sucesso!',
  message = 'Operação realizada com sucesso.',
  buttonText = 'Entendi',
  size = 'md'
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size={size}>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>
          <Icon icon="mdi:check-circle" className="me-2" />
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="text-center">
          <Icon icon="mdi:check-circle" className="text-success" style={{ fontSize: '2.5rem' }} />
          <h6 className="mt-3 mb-2">Operação Realizada com Sucesso!</h6>
          <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
            {message}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-light border-top">
        <Button variant="success" onClick={onHide}>
          <Icon icon="mdi:check" className="me-2" />
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal; 